export function sanitizeText(text) {
  if (typeof text !== "string") return text;
  return text.replace(/[^a-zA-Z0-9ğüşöçıİĞÜŞÖÇ\s.,!?]/g, ""); 
}